import { JSX, useEffect } from "react";
import { useSubscription } from "@apollo/client";
import { AgendaPost, OnCreateAgendaPostByCompanyIdSubscription, OnCreateAgendaPostByCompanyIdSubscriptionVariables } from "../../../graphql/API";
import { onCreateAgendaPostByCompanyId } from "../queries";

const SubscriptionComPostWrapper = ({ comId, userId, chatterId, onNewPost, subscriptionKey, onError }: {
    comId: string;
    userId: string;
    chatterId: string;
    onNewPost: (post: AgendaPost) => void;
    subscriptionKey: number;
    onError?: () => void;
  }): JSX.Element | null => {
    const {data, error} = useSubscription<
        OnCreateAgendaPostByCompanyIdSubscription, 
        OnCreateAgendaPostByCompanyIdSubscriptionVariables
        >(onCreateAgendaPostByCompanyId, 
            {variables: {comId: comId, filter : {
                or: [
                    { room: { eq: userId+chatterId } },
                    { room: { eq: chatterId+userId } }
                ]
            }}});
  
    useEffect(() => {
      // if (data?.onCreateAgendaPostByCompanyId) {
      //   onNewPost(data.onCreateAgendaPostByCompanyId as AgendaPost);
      // }
      const roomId = [userId, chatterId].sort().join("");
      const post = data?.onCreateAgendaPostByCompanyId;
      if (post?.room === roomId) {
        onNewPost(post as AgendaPost);
      }
    }, [data]);
  
    useEffect(() => {
        if (error) {
          console.error("Subscription error");//:", error);
          onError?.();
        }
      }, [error]);
  
    return null;
  };
 export default SubscriptionComPostWrapper  